import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import i18n from 'i18n-js';
import { IconButton } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/Delete';

import styles from '../styles';
import { theme } from 'config/theme';
import { PriceOptionForm } from './PriceOptionForm';
import { useAppSelector } from 'index';
import { actionCreators } from 'store/restaurantDetailsStore/actionCreators';
interface AdvancedPriceOptionProps {
    id?: string;
    name?: string;
    disabled?: boolean;
}

export function AdvancedPriceOption({
    name = i18n.t('common.standard'),
    id = '',
    disabled = false,
}: AdvancedPriceOptionProps) {
    const classes = styles();
    const dispatch = useDispatch();
    const restaurant = useAppSelector((state) => state.restaurantDetails.restaurantInformation);
    const [edit, setEdit] = useState(false);

    function editOption(newName: string) {
        setEdit(false);
        dispatch(actionCreators.updatePricingLevel(restaurant.id, id, newName));
    }
    function deleteOption() {
        setEdit(false);
        dispatch(actionCreators.deletePricingLevel(restaurant.id, id));
    }

    return edit ? (
        <PriceOptionForm name={name} action={editOption} cancel={() => setEdit(false)} />
    ) : (
        <div className={classes.priceItemContainer}>
            {name}
            {!disabled && (
                <div>
                    <IconButton
                        onClick={() => {
                            setEdit(true);
                        }}
                    >
                        <CreateIcon htmlColor={theme.palette.secondary.dark} />
                    </IconButton>
                    <IconButton onClick={deleteOption}>
                        <DeleteIcon htmlColor={theme.palette.secondary.dark} />
                    </IconButton>
                </div>
            )}
        </div>
    );
}
